module.exports = __webpack_public_path__ + "img/IMG_0459_L_Black_MockedUp.bf2c8040.jpg";